function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.735073 8.99938C0.924127 8.99938 1.11306 8.9236 1.2568 8.77149L4.78616 5.04303C5.071 4.7426 5.071 4.25676 4.78616 3.95597L1.2568 0.22732C0.970702 -0.07508 0.505042 -0.0767 0.21688 0.22354C-0.0711648 0.523612 -0.0728838 1.01234 0.213334 1.31438L3.22816 4.4994L0.213334 7.68443C-0.0728838 7.98684 -0.0711648 8.4752 0.21688 8.77545C0.360277 8.92486 0.547729 8.99938 0.735073 8.99938Z",
  fill: "#969696"
});

function SvgBreadcrumbArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgNSA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNzM1MDczIDguOTk5MzhDMC45MjQxMjcgOC45OTkzOCAxLjExMzA2IDguOTIzNiAxLjI1NjggOC43NzE0OUw0Ljc4NjE2IDUuMDQzMDNDNS4wNzEgNC43NDI2IDUuMDcxIDQuMjU2NzYgNC43ODYxNiAzLjk1NTk3TDEuMjU2OCAwLjIyNzMyQzAuOTcwNzAyIC0wLjA3NTA4IDAuNTA1MDQyIC0wLjA3NjcgMC4yMTY4OCAwLjIyMzU0Qy0wLjA3MTE2NDggMC41MjM2MTIgLTAuMDcyODgzOCAxLjAxMjM0IDAuMjEzMzM0IDEuMzE0MzhMMy4yMjgxNiA0LjQ5OTRMMC4yMTMzMzQgNy42ODQ0M0MtMC4wNzI4ODM4IDcuOTg2ODQgLTAuMDcxMTY0OCA4LjQ3NTIgMC4yMTY4OCA4Ljc3NTQ1QzAuMzYwMjc3IDguOTI0ODYgMC41NDc3MjkgOC45OTkzOCAwLjczNTA3MyA4Ljk5OTM4WiIgZmlsbD0iIzk2OTY5NiIvPgo8L3N2Zz4K";
export { SvgBreadcrumbArrow as ReactComponent };